import { render } from "./ListOrder.vue?vue&type=template&id=35daf770&scoped=true"
import script from "./ListOrder.vue?vue&type=script&lang=js"
export * from "./ListOrder.vue?vue&type=script&lang=js"

import "./ListOrder.vue?vue&type=style&index=0&id=35daf770&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35daf770"]])

export default __exports__